import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

interface PropertyStatusProps {
  data: {
    rented: number;
    vacant: number;
  };
}

const PropertyStatus: React.FC<PropertyStatusProps> = ({ data }) => {
  const chartData = {
    labels: ['Rented', 'Vacant'],
    datasets: [
      {
        data: [data.rented, data.vacant],
        backgroundColor: [
          'rgba(75, 192, 192, 0.5)',
          'rgba(255, 99, 132, 0.5)',
        ],
        borderColor: [
          'rgba(75, 192, 192, 1)',
          'rgba(255, 99, 132, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right' as const,
        align: 'center' as const,
        labels: {
          boxWidth: 12,
          padding: 15,
          font: {
            size: window.innerWidth <= 768 ? 10 : 12
          }
        }
      }
    }
  };

  return (
    <div className="chart-container">
      <Pie data={chartData} options={options} />
    </div>
  );
};

export default PropertyStatus;
